export const internetHeader = "Internetverbindung konfigurieren";

export const internetTexts = [
  {
    type: "text",
    content:
      "Falls sich Ihr WLAN-Zugang geändert und Ihr Energieimpuls kein Internet mehr hat, muss der Energieimpuls " +
      "mithilfe Ihres Smartphones wieder ins WLAN eingebunden werden. Folgend finden Sie eine " +
      "Schritt-für-Schritt-Anleitung, um den Energieimpuls wieder mit Ihrem WLAN zu verbinden:",
  },
  { type: "space" },
  {
    type: "subtitle",
    content: "Smartphone mit dem Energieimpuls verbinden",
  },
  {
    type: "text",
    content:
      "Wenn Ihr Energieimpuls keine Internetverbindung hat, öffnet er einen Hotspot mit folgenden Zugangsdaten:",
  },
  { type: "key", key: "internet-credentials" },
  {
    type: "text",
    content:
      "Verbinden Sie Ihr Smartphone in den WLAN-Einstellungen mit dem Hotspot des Energieimpulses. Ihr " +
      "Smartphone muss während des gesamten Konfigurationsvorgangs mit diesem Hotspot verbunden bleiben. Dabei " +
      "kann gelegentlich an Ihrem Smartphone eine Meldung erscheinen, dass keine Internetverbindung im WLAN " +
      "verfügbar ist, da der Energieimpuls keine Internetverbindung bereitstellt. Ignorieren Sie diese Meldung Ihres " +
      "Smartphones und bleiben Sie mit dem Hotspot des Energieimpulses verbunden",
  },
  { type: "space" },
  {
    type: "subtitle",
    content: "Zur Webseite navigieren",
  },
  { type: "space" },
  { type: "key", key: "navigate-to-webpage" },
  { type: "space" },
  {
    type: "subtitle",
    content: "WLAN-Daten eingeben",
  },
  {
    type: "text",
    content:
      "Der Energieimpuls sucht nach verfügbaren WLAN-Netzwerken und zeigt diese an. Falls Ihr WLAN-Zugang nicht " +
      'anzeigt wird, klicken Sie auf "Erneut suchen", um den Suchvorgang zu wiederholen. Wählen Sie Ihren ' +
      "WLAN-Zugang, indem Sie das entsprechende Feld klicken, und geben Sie das Passwort in das entsprechende Feld " +
      'ein. Klicken Sie anschließend "Anmelden".',
  },
  {
    type: "text",
    content:
      "Der Energieimpuls gibt eine Meldung auf der Webseite aus, wenn erfolgreich eine Verbindung zum Internet " +
      "hergestellt worden ist. Im Anschluss wird der WLAN-Hotspot automatisch ausgeschaltet. Dieser ist immer nur " +
      "dann verfügbar, wenn keine Internetverbindung besteht.",
  },
  { type: "space" },
  {
    type: "subtitle",
    content: "Probleme bei der Herstellung einer WLAN-Verbindung",
  },
  {
    type: "text",
    content:
      "Sollte trotz gefundenem WLAN-Netzwerk und korrekt eingegebenem Passwort keine Internetverbindung " +
      "hergestellt werden, kann dies auf mehrere Probleme zurückzuführen sein:",
  },
  {
    type: "enumeration",
    content: [
      "Die Verbindungsqualität des WLANs ist zu schlecht. Bitte verstärken Sie das Signal, bspw. mit einem Repeater.",
      "Ihre WLAN-Verschlüsselung ist mit WPA3 konfiguriert (häufig bei Telekom Speedport Smart 4). Bitte " +
        "konfigurieren Sie die Verschlüsselungsmethode zu WPA2 um, da WPA3 nicht unterstützt wird. Alternativ " +
        "können Sie ein Gast-WLAN-Netzwerk mit eingeschränktem Zugriff erzeugen und nur für dieses " +
        "WLAN-Netzwerk die WPA2-Methode konfigurieren.",
    ],
  },
];
